import { render, staticRenderFns } from "./column-number-filter.vue?vue&type=template&id=4dd2233a"
import script from "./column-number-filter.vue?vue&type=script&lang=js"
export * from "./column-number-filter.vue?vue&type=script&lang=js"
import style0 from "./column-number-filter.vue?vue&type=style&index=0&id=4dd2233a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports